<div class="container">
  <h1 class="welcome-header">Tax Forms</h1>
  <ng-container>
    <app-p8-documents-error-page *ngIf="hasServerError" [messageHeader]="messageHeader" [messageBody]="messageBody">
    </app-p8-documents-error-page>
  </ng-container>
  <div class="loader-container" *ngIf="isLoading; else showLetters">
    <dxo-circular-loader text="Loading..."></dxo-circular-loader>
  </div>
  <ng-template #showLetters>
    <div class="parent" *ngIf="!hasServerError && !isLoading">
      <div id="letter-card" *ngIf="totalLines > 0">
        <dxo-card bodyHeader="Schedule A letters">
          <card-body *ngIf="letters$ | async as letters">
            <dxo-data-table
              [headers]="tableHeaders"
              [items]="letters"
              [showCardViewWhenMobile]="true"
              [dxoDataset]="[{ selector: 'dxo-table-cell > span', data: { pii: '' } }]"
            >
              <ng-template dxoHeaderKey="planYear">
                <span
                  tabindex="0"
                  class="sort-header"
                  (click)="onClickTableHeader('StatementDate')"
                  (keypress)="onClickTableHeader('StatementDate')"
                >
                  Year of policy or contracts
                  <dxo-icon
                    [class.ascending]="
                      searchParameter.sortDirection === 'Ascending' && searchParameter.sortField === 'StatementDate'
                    "
                    [color]="searchParameter.sortField === 'StatementDate' ? 'blue' : 'gray'"
                    [fontSize]="20"
                    [right]="true"
                  >
                    sort
                  </dxo-icon>
                </span>
              </ng-template>

              <ng-template dxoKey="pdfUrl" let-item>
                <a class="download-link" [href]="item.pdfUrl" target="_blank">
                  <span>View</span>
                  <dxo-icon color="currentColor" [right]="true"> open_in_new </dxo-icon>
                </a>
              </ng-template>
            </dxo-data-table>
            <div class="paginator row">
              <dxo-server-pagination
                [itemCount]="totalLines"
                [currentPage]="searchParameter.page"
                [pageSize]="searchParameter.pageSize"
                (pageChange)="onPageChange($event)"
                (pageSizeChange)="onPageSizeChange($event)"
              ></dxo-server-pagination>
            </div>
          </card-body>
        </dxo-card>
      </div>

      <div id="request-card">
        <dxo-card bodyHeader="Request a Schedule A letter">
          <card-body>
            <form [formGroup]="formGroup" (ngSubmit)="submit()" #myForm="ngForm">
              <div class="data-containter">
                <div class="dateLabel">Enter date range</div>
                <div class="row-input">
                  <div class="input-lable">From (MM/DD/YYYY)</div>
                  <div class="input-lable">To (MM/DD/YYYY)</div>
                </div>
                <div class="row-input">
                  <dxo-text-input
                    class="input-300"
                    input-id="fromDate"
                    [maxlength]="10"
                    autocomplete="fromDay"
                    type="date"
                    [characterSet]="dateCharRegex"
                    formControlName="fromDate"
                    [errorControl]="formErrors.fromDate"
                  >
                  </dxo-text-input>

                  <dxo-text-input
                    class="input-300"
                    input-id="ToDate"
                    [maxlength]="10"
                    autocomplete="toDay"
                    type="date"
                    [characterSet]="dateCharRegex"
                    formControlName="toDate"
                    [errorControl]="formErrors.toDate"
                  >
                  </dxo-text-input>
                </div>
              </div>
              <dxo-button
                [primary]="true"
                text="Submit a Schedule A request"
                data-category="request"
                data-action="Close Modal"
                (handleClick)="request()"
                [disabled]="formGroup.pristine"
              >
              </dxo-button>
            </form>
          </card-body>
        </dxo-card>
      </div>
    </div>
  </ng-template>
</div>

<dxo-modal *ngIf="open && !modalSuccess" [shouldShowCloseX]="false">
  <modal-body class="loader-container">
    <dxo-circular-loader text="Loading..." [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
  </modal-body>
</dxo-modal>
<dxo-modal
  *ngIf="open && modalSuccess"
  title="We received your Tax Form request"
  [maxWidth]="470"
  [shouldShowCloseX]="false"
>
  <modal-body>
    <p>Thank you for your Tax Form request. Processing the request may take two business days to complete.</p>
    <p>An email confirmation is on the way.</p>
    <dxo-button text="Close" color="blue" (handleClick)="closePopup()"></dxo-button>
  </modal-body>
</dxo-modal>
